export default __webpack_public_path__ + "static/media/29-TimeEntertainment-Logo.1bdcff27.jpg";